export default __webpack_public_path__ + "static/media/intensity4.73cc66b8.svg";